import { Link } from "react-router-dom";
import { useT } from "../../lib/texte";

// `logo.svg` hat viewBox="0 0 321.5 150" — bei 30 px Höhe sind das 64 px Breite.
// Beide Zahlen stehen als Attribute am <img>, damit der Browser den Platz schon vor
// dem Laden reserviert und die Kopfleiste beim ersten Anstrich nicht springt.
const LOGO_H = 30;
const LOGO_W = 64;

/**
 * Bildmarke plus Produktwort — „Katalog" statt „Projekte" (SPEC §13.2). `logo.svg`
 * ist die LILASp-Wortmarke aus webgis, unverändert. `--logo-filter` hellt die graue
 * Marke im dunklen Thema auf; ohne ihn versinkt sie im Grund.
 */
export function Logo({ zu = "/" }: { zu?: string }) {
  const { t } = useT();
  return (
    <Link to={zu} className="marke ring-focus" aria-label={`${t.marke.name} ${t.marke.produkt}`}>
      <img src="/logo.svg" alt={t.marke.name} width={LOGO_W} height={LOGO_H} />
      <span aria-hidden>{t.marke.produkt}</span>
    </Link>
  );
}
